export default "__VITE_ASSET__6fb47826__"